import React, {useCallback, useEffect} from 'react';
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {Card, CardBody, Col, Row} from "reactstrap";
import ShelterPetList from "./List/ShelterPetList";
import {connect} from "react-redux";
import {addPet, adoptedShelterPet, editPet, getPets, removePet, showAddPetModal} from "../../store/pet/actions";
import {userRols} from "../../helpers/userRols";
import Paging from "components/Pagination/Pagination";
import ListSearch from "components/ListSearch/ListSearch";

const ShelterPet = ({petList, adoptedShelterPet, getPets, removePet, query}) => {
    const { page: currentPage, pageSize, q } = query;
    const total = petList?.total || 0;
    const pages = petList?.pages || 1;

    useEffect(() => {
        getPets({role: userRols.shelter})
    }, [getPets]);

    const setPage = useCallback((page) => {
        getPets({ role: userRols.shelter, page });
    }, [getPets]);

    const setPageSize = useCallback((pageSize) => {
        getPets({ role: userRols.shelter, pageSize, page: 1 });
    }, [getPets]);

    const handleSearch = useCallback((q) => {
        getPets({ role: userRols.shelter, q, page: 1 });
    }, [getPets]);

    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Домашни любимци" breadcrumbItem="Домашни любимци" />

                    <Row>
                        <Col>
                            <Card>
                                <CardBody>
                                    <div className="list-toolbar mb-3">
                                        <Paging
                                            setPage={setPage}
                                            setPageSize={setPageSize}
                                            pageSize={pageSize}
                                            currentPage={currentPage}
                                            pages={pages}
                                        />
                                        <ListSearch
                                            value={q || ""}
                                            onSearch={handleSearch}
                                            placeholder="Търсене по любимец или порода"
                                        />
                                    </div>

                                    <div className="mb-2 text-muted">
                                        Общо: {total} домашни любимци
                                    </div>

                                    <ShelterPetList
                                        petListData={petList}
                                        onRemoveItem={removePet}
                                        adoptedShelterPet={adoptedShelterPet}
                                    />
                                </CardBody>
                                <Paging
                                    setPage={setPage}
                                    setPageSize={setPageSize}
                                    pageSize={pageSize}
                                    currentPage={currentPage}
                                    pages={pages}
                                />
                            </Card>
                        </Col>
                    </Row>
                </div>
            </div>
        </React.Fragment>
    );
};

const mapStateToProps = (state) => {
    const { Pet } = state;
    return Pet;
};

export default connect(mapStateToProps, {
    getPets,
    addPet,
    showAddPetModal,
    removePet,
    editPet,
    adoptedShelterPet
})(ShelterPet);